export default class BookingColor {

    constructor(data) {
        this.text = null;
        this.background = null;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/booking-color.model.js